module.exports = __webpack_public_path__ + "static/media/onboarding-machine-options.9a88d384.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/onboarding-machine-options.png
// module id = 2640
// module chunks = 0